// ###### IMPORTS
import React from 'react';
import AssetsOverview from './view_assets_overview';
import AssetsDetailed from './view_assets_detailed';
import AssetsManage from './view_assets_manage';

// ###### MAIN COMPONENT
const AssetsMain = ({ activeTabL1, yearsRange }) => {
  return (
    <div className="w-full flex flex-col gap-2">
      {activeTabL1 === 'board' && <AssetsOverview />}
      {activeTabL1 === 'detailed' && <AssetsDetailed />}
      {activeTabL1 === 'manage' && <AssetsManage yearsRange={yearsRange} />}
    </div>
  );
};

export default AssetsMain;
